import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-preview-survey-number-rating',
  templateUrl: './preview-survey-number-rating.component.html',
  styleUrls: ['./preview-survey-number-rating.component.scss']
})
export class PreviewSurveyNumberRatingComponent {

  numberOfOption: any
  constructor(public sanitizer: DomSanitizer) { }
  @Input() questions: any;
  @Input() isReadOnly: boolean;
  @Input() displayMode: string;
  @Input() set optionOfNumber(data: any) {
    if (data && data.length) {
      this.numberOfOption = data;
    }
  };
}
